import { z } from "zod";
import { defineEndpoint, idParamsSchema } from "./endpoint.js";
/**
 * DG-04 (ACC-08, docs/specs/shopper-accounts.md): the shop's online accounts in the Admin — a searchable list, and
 * disabling, enabling or signing an account out everywhere. Passwords and session secrets never leave the API.
 */
const tag = { tag: "storefront" };
const view = { permission: "shopper_accounts.view" };
const manage = { permission: "shopper_accounts.manage" };
export const adminShopperAccountSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    email: z.string().nullable(),
    emailVerified: z.boolean(),
    phone: z.string().nullable(),
    phoneVerified: z.boolean(),
    hasPassword: z.boolean(),
    google: z.boolean(),
    status: z.enum(["active", "disabled"]),
    createdAt: z.iso.datetime(),
    lastSignInAt: z.iso.datetime().nullable(),
    version: z.int(),
});
export const shopperAccountListQuerySchema = z.object({
    /** Name, email or mobile number (part of it). */
    q: z.string().trim().max(100).optional(),
    status: z.enum(["active", "disabled"]).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
    cursor: z.uuid().optional(),
});
export const listShopperAccounts = defineEndpoint({
    ...tag,
    name: "listShopperAccounts",
    method: "GET",
    path: "/v1/shopper-accounts",
    access: view,
    summary: "The online store's shopper accounts, newest first; search by name, email or mobile",
    query: shopperAccountListQuerySchema,
    status: 200,
    response: z.object({ data: z.array(adminShopperAccountSchema), nextCursor: z.uuid().nullable() }),
});
export const setShopperAccountStatus = defineEndpoint({
    ...tag,
    name: "setShopperAccountStatus",
    method: "POST",
    path: "/v1/shopper-accounts/{id}/status",
    access: manage,
    summary: "Disable an account (it is signed out everywhere and cannot sign in) or enable it again; audited",
    params: idParamsSchema,
    body: z.object({ status: z.enum(["active", "disabled"]), version: z.int().min(1) }).strict(),
    status: 200,
    response: adminShopperAccountSchema,
    errors: ["NOT_FOUND", "CONFLICT"],
});
export const signOutShopperAccount = defineEndpoint({
    ...tag,
    name: "signOutShopperAccount",
    method: "POST",
    path: "/v1/shopper-accounts/{id}/sign-out",
    access: manage,
    summary: "Sign an account out on every device; audited",
    params: idParamsSchema,
    status: 204,
    errors: ["NOT_FOUND"],
});
//# sourceMappingURL=shopper-accounts-admin.js.map